export default __webpack_public_path__ + "static/ringwithblob-aa84bf58f13db1f239c81ece00924903.png";